import { memo } from "react";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from "@mui/material";

import styles from "./RadioGroupField.module.scss";
interface Option {
  value: string;
  label: string;
}

interface RadioGroupFieldProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  label: string;
  options: Option[];
  row?: boolean;
  className?: string;
}

const RadioGroupField = <T extends FieldValues>({
  name,
  control,
  label,
  options,
  row = false,
  className,
}: RadioGroupFieldProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <FormControl
          component="fieldset"
          error={!!fieldState.error}
          className={`${className} ${styles.label}`}
        >
          <FormLabel component="legend">{label}</FormLabel>
          <RadioGroup {...field} row={row}>
            {options.map(option => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
              />
            ))}
          </RadioGroup>
          {fieldState.error && (
            <FormHelperText>{fieldState.error.message}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
};

export default memo(RadioGroupField) as typeof RadioGroupField;
